import { Component, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MapSettings } from 'app/models/settings/map-settings';
import { Subject } from 'rxjs';


// Set up a new provider to tell angular that this component supports
// ControlValueAccessor methods and forms
const EDIT_MAP_SETTINGS_VALUE_ACCESSOR = {
   provide: NG_VALUE_ACCESSOR,
   useExisting: forwardRef(() => EditMapSettingsComponent),
   multi: true
};

@Component({
  selector: 'edit-map-settings',
  templateUrl: './edit-map-settings.component.html',
    providers: [EDIT_MAP_SETTINGS_VALUE_ACCESSOR]
})
export class EditMapSettingsComponent {

  @Input() displayHeading: boolean = true;

  // This is used by the scroll pane to determine the scroll height.
  @Input() scrollHeight: number;
     
   // Provides access for the parent component to access the validation status of this form.
  @ViewChild('mapSettingsForm') mapSettingsForm;

  // variables for comparison
 /*  public autoZoom: boolean;
  public blackAndWhite: boolean;
  public clusterPoints: boolean;
  public directRoutes: boolean;
  public callerDotIcon: boolean;
  public visitDotIcon: boolean;
  public frequency: boolean; */

    //product owner wants to reverse the toggle button on this so standard is on left real pain
   public get useMapClusterPoints() {
    return !this.mapSetting.clusterPoints;
   }

   //product owner wants to reverse the toggle button on this so standard is on left real pain
   public set useMapClusterPoints(isAuto) {
    this.mapSetting.clusterPoints = !isAuto;
   }

  // Event raised when the state of the Form changes.
  private _formStateChanged = new Subject<boolean>();
  public formState$ = this._formStateChanged.asObservable();
  public originalMapSetting: MapSettings;

  private _mapSetting: MapSettings;// Model object which cached the info from the wizard.
  get mapSetting(): MapSettings {
    return this._mapSetting;
  }
  set mapSetting(newMapSetting: MapSettings) {
    this._mapSetting = newMapSetting;
    this.initialiseModel(newMapSetting);
  }
 
  // Registers a callback method to invoke when a change event happens.
  registerOnChange(fn: any): void {}

   // Registers a callback method to invoke when a touch event happens.
  registerOnTouched(fn: any): void {}

  constructor() {}
  
  initialiseModel(newMapSetting: MapSettings){
    if (newMapSetting == null) return;
    this.originalMapSetting = new MapSettings();
    this.originalMapSetting.autoZoom = newMapSetting.autoZoom;
    this.originalMapSetting.blackAndWhite = newMapSetting.blackAndWhite;
    this.originalMapSetting.clusterPoints = newMapSetting.clusterPoints;
    this.originalMapSetting.directRoutes = newMapSetting.directRoutes;
    this.originalMapSetting.callerDotIcon = newMapSetting.callerDotIcon;
    this.originalMapSetting.visitDotIcon = newMapSetting.visitDotIcon;
    this.originalMapSetting.frequency = newMapSetting.frequency;
  }

  // Callback method to sync the form values with this model.
  writeValue(data: any): void {
    this.mapSetting = data;
  }

  public onAnyInputSwitchChanged(event: any) {
    const haveNoChanges =  this.mapSetting.autoZoom == this.originalMapSetting.autoZoom 
    && this.mapSetting.blackAndWhite == this.originalMapSetting.blackAndWhite
    && this.mapSetting.callerDotIcon == this.originalMapSetting.callerDotIcon 
    && this.mapSetting.clusterPoints ==  this.originalMapSetting.clusterPoints
    && this.mapSetting.directRoutes == this.originalMapSetting.directRoutes 
    && this.mapSetting.visitDotIcon == this.originalMapSetting.visitDotIcon
    && this.mapSetting.frequency == this.originalMapSetting.frequency; 
      
    haveNoChanges ? this.mapSettingsForm.form.markAsPristine() : this.mapSettingsForm.form.markAsDirty();
    this._formStateChanged.next(!haveNoChanges);
   }
}
